import { UseFormReturn } from 'react-hook-form';

import { WorkSchedule } from '@/modules/common/api';
import { DayOfWeek, dayOfWeekToOrdinal } from '@/types/day-of-week';

import { OrganizationFormValues } from '../schemas/organization-schema';

/**
 * Converts minuteOfTheDay since midnight to a 24-hour time string (e.g., "09:00").
 */
export function formatMinuteOfTheDayToTime(minuteOfTheDay: number): string {
  if (minuteOfTheDay < 0 || minuteOfTheDay >= 24 * 60) {
    minuteOfTheDay = 9 * 60; // Default to 09:00
  }
  const hours = Math.floor(minuteOfTheDay / 60);
  const mins = minuteOfTheDay % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}

/**
 * Applies the default work schedule (9:00am to 5:00pm for weekdays) to the form.
 */
export function applyDefaultWorkSchedule(form: UseFormReturn<OrganizationFormValues>) {
  const defaultSchedule = WorkSchedule.getDefaultWorkSchedule();
  Object.values(DayOfWeek).forEach(dayOfWeek => {
    const ordinal = dayOfWeekToOrdinal(dayOfWeek);
    const defaultDay = defaultSchedule.days.find(day => day.dayOfWeek === ordinal);
    if (defaultDay) {
      form.setValue(`workSchedule.${dayOfWeek}.enabled` as const, true);
      form.setValue(
        `workSchedule.${dayOfWeek}.startTime` as const,
        formatMinuteOfTheDayToTime(defaultDay.startTimeMinutes)
      );
      form.setValue(
        `workSchedule.${dayOfWeek}.endTime` as const,
        formatMinuteOfTheDayToTime(defaultDay.endTimeMinutes)
      );
    } else {
      form.setValue(`workSchedule.${dayOfWeek}.enabled` as const, false);
      form.setValue(`workSchedule.${dayOfWeek}.startTime` as const, null);
      form.setValue(`workSchedule.${dayOfWeek}.endTime` as const, null);
    }
  });
}
